import * as z from 'zod';

export const companyIdInitialValue = 0;
export const companyOrderInitialValue = 0;
export const otherCompanyId = 99999;

export const initialWorkplace = {
  companyOrder: companyOrderInitialValue,
  companyId: companyIdInitialValue,
  companyName: '',
  joinedDate: {
    year: '',
    month: ''
  },
  retiredDate: {
    year: '',
    month: ''
  },
  stayNow: false,
  isLatest: false
} as const;

export const workplaceSchema = z.array(
  z.object({
    companyOrder: z.number().min(0),
    companyId: z.number().min(0),
    companyName: z.string().min(0).max(100),
    joinedDate: z.object({
      year: z.string(),
      month: z.string()
    }),
    retiredDate: z.object({
      year: z.string(),
      month: z.string()
    }),
    stayNow: z.boolean(),
    isLatest: z.boolean()
  })
);

export type WorkplaceSchemaSchema = z.infer<typeof workplaceSchema>;
